export default __webpack_public_path__ + "static/media/Blog11.e3b75c2e.png";